import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner } from "react-bootstrap";
import { TablePlaceholder } from "../../components/placeholders";
import { formatCurrency } from "../../helpers/utils";
import { TABLE_COLUMN_WIDTHS } from "../../helpers/tableColumnWidths";
import ImageWithLoader from "../../components/image";
import CustomLoader from "../../components/loader";

const styles = {
  table: {
    className: "table table-centered mb-0",
  },
  thCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),
  tdCenter: (width) => ({
    textAlign: "center",
    width: width,
  }),

  tdCenterDiscount: {
    textAlign: "center",
    backgroundColor: "#ff2d55",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  tdCenterBonus: {
    textAlign: "center",
    backgroundColor: "#00C27A",
    color: "white",
    border: "none",
    borderRadius: "6px",
    padding: "6px 12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  actionButton: {
    background: "none",
    border: "none",
    padding: 0,
  },
  loaderWrapper: {
    textAlign: "center",
    padding: "0.5rem",
  },
  endMessage: {
    textAlign: "center",
    color: "#6c757d",
    marginTop: "2rem",
    fontSize: 13,
  },
};

export default function ProductTable({
  items,
  loading,
  hasMore,
  onEndReached,
  loadingProductId,
  handleVisible,
  onEdit,
  onDelete,
  onDiscount,
  onBonus,
}) {
  const COLUMN_WIDTHS = TABLE_COLUMN_WIDTHS.editTalbe;

  return (
    <div className="table-responsive-sm">
      <InfiniteScroll
        dataLength={items?.length || 0}
        next={onEndReached}
        hasMore={hasMore}
        scrollThreshold={0.9}
        loader={
          <div style={styles.loaderWrapper}>
            <CustomLoader fontSize={32} />
          </div>
        }
        endMessage={
          !hasMore && <p style={styles.endMessage}>Төгсгөлд нь хүрсэн байна</p>
        }
      >
        <table className={styles.table.className}>
          <thead>
            <tr>
              {/* <th style={styles.thCenter(COLUMN_WIDTHS.active)}>Идэвхтэй</th> */}
              <th style={styles.thCenter(COLUMN_WIDTHS.image)}>Зураг</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.name)}>Нэр</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Үнэ</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Хямд.Үнэ</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Хямд.Хувь</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Хямдрал</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>У.Бараа</th>
              <th style={styles.thCenter(COLUMN_WIDTHS.price)}>Урамшуулал</th>
            </tr>
          </thead>
          <tbody>
            {loading && items.length === 0 ? (
              <TablePlaceholder rows={12} count={7} />
            ) : (
              items?.map((item) => {
                const isUpdating = loadingProductId === item.id;

                return (
                  <tr key={item.id}>
                    {/* <td style={styles.tdCenter(COLUMN_WIDTHS.active)}>
                      {isUpdating ? (
                        <Spinner
                          animation="border"
                          size="sm"
                          role="status"
                          className="ms-3"
                        />
                      ) : (
                        <div>
                          <input
                            type="checkbox"
                            id={`switch_${item.id}`}
                            checked={item.isVisible}
                            data-switch="danger"
                            onChange={(e) => handleVisible(e, item.id)}
                          />
                          <label
                            htmlFor={`switch_${item.id}`}
                            data-on-label="On"
                            data-off-label="Off"
                          />
                        </div>
                      )}
                    </td> */}

                    <td style={styles.tdCenter(COLUMN_WIDTHS.image)}>
                      <ImageWithLoader
                        src={item.image}
                        alt={item.name}
                        width="40px"
                        height="40px"
                        className="avatar-sm"
                      />
                    </td>

                    <td style={styles.tdCenter(COLUMN_WIDTHS.name)}>
                      {item.name}
                    </td>

                    {/* Үндсэн үнэ */}
                    <td style={styles.tdCenter(COLUMN_WIDTHS.price)}>
                      {formatCurrency(item.price)}
                    </td>

                    {/* Хямд. Үнэ */}
                    <td style={styles.tdCenter(COLUMN_WIDTHS.price)}>
                      {item.discountIsActive && item.discountPrice
                        ? formatCurrency(item.discountPrice)
                        : "-"}
                    </td>

                    {/* Хямд. Хувь */}
                    <td style={styles.tdCenter(COLUMN_WIDTHS.price)}>
                      {item.discountIsActive && item.discountPercent
                        ? `${item.discountPercent}%`
                        : "-"}
                    </td>

                    {/* Хямдрах товч */}
                    <td style={styles.tdCenter(COLUMN_WIDTHS.delete)}>
                      <button
                        onClick={() => onDiscount(item)}
                        style={styles.tdCenterDiscount}
                      >
                        Хямдрах
                      </button>
                    </td>

                    <td style={styles.tdCenter(COLUMN_WIDTHS.image)}>
  {item.bonusCount > 0 ? (
    <span
      style={{
        background: "#00C27A",
        color: "white",
        padding: "4px 10px",
        borderRadius: "6px",
        fontWeight: "600",
      }}
    >
      {item.bonusCount}
    </span>
  ) : (
    <span className="text-muted">-</span>
  )}
                    </td>

                    {/* Урамшуулал товч */}
                    <td style={styles.tdCenter(COLUMN_WIDTHS.delete)}>
                      <button
                        onClick={() => onBonus(item)}
                        style={styles.tdCenterBonus}
                      >
                        Урамшуулал
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </InfiniteScroll>
    </div>
  );
}
